'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _reactGridforms = require('react-gridforms');

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _immutable2 = require('react-redux-form/immutable');

var _search = require('react-icons/lib/md/search');

var _search2 = _interopRequireDefault(_search);

var _bisuReactInput = require('bisu-react-input');

var _bisuReactInput2 = _interopRequireDefault(_bisuReactInput);

var _bisuReactFormError = require('bisu-react-form-error');

var _bisuReactFormError2 = _interopRequireDefault(_bisuReactFormError);

var _trim = require('validator/lib/trim');

var _trim2 = _interopRequireDefault(_trim);

var _search3 = require('./search');

var _search4 = _interopRequireDefault(_search3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BisuReactRowSearch = function (_Component) {
  _inherits(BisuReactRowSearch, _Component);

  function BisuReactRowSearch(props) {
    _classCallCheck(this, BisuReactRowSearch);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._openSearch = function () {
      _this.setState({
        openSearch: true
      });
    };

    _this._closeSearch = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          model1 = _this$props.model1;

      _this.setState({
        openSearch: false
      });
      dispatch(_immutable2.actions.focus(model1));
    };

    _this._fuzzySearch = function (term, setFirstResult) {
      var searchResults = _this.props.searchResults;

      var regex = new RegExp(term, 'i');
      var filtered = searchResults.filter(function (item) {
        return item.get('code').search(regex) > -1 || item.get('name').search(regex) > -1;
      });
      _this.setState({ filtered: filtered });
      if (setFirstResult === true) {
        if (filtered.size > 0) {
          _this._onSelectSearchItem(filtered.get(0));
        } else {
          _this._reset();
        }
      }
    };

    _this._onKeyDown = function (e) {
      var filtered = _this.state.filtered;
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          onSearch = _this$props2.onSearch,
          isOffline = _this$props2.isOffline,
          searchResults = _this$props2.searchResults;


      if (e.keyCode === 121) {
        // show search
        _this._openSearch();
      }
      if (e.keyCode === 13) {
        e.preventDefault();
        // search directly
        var value = (0, _trim2.default)(e.target.value);
        if (!value) {
          _this._reset();
          return true;
        }
        if (isOffline) {
          // fuzzy search
          _this._fuzzySearch(value, true);
        } else {
          _this.props.dispatch(_this.props.onSearch(value)).then(function (res) {
            if (!res.error) {
              var result = (0, _immutable.fromJS)(res.payload || []);
              if (result.size > 0) {
                _this._onSelectSearchItem(result.get(0));
              } else {
                _this._reset();
              }
            } else {
              _this._reset();
            }
          });
        }
      }
    };

    _this._onSearch = function (term) {
      var _this$props3 = _this.props,
          isOffline = _this$props3.isOffline,
          dispatch = _this$props3.dispatch,
          onSearch = _this$props3.onSearch;

      if (isOffline) {
        _this._fuzzySearch(term);
      } else {
        dispatch(onSearch(term));
      }
    };

    _this._onSelectSearchItem = function (item) {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          model = _this$props4.model,
          model1 = _this$props4.model1,
          model2 = _this$props4.model2;

      dispatch(_immutable2.actions.change(model, item.get('id')));
      dispatch(_immutable2.actions.change(model1, item.get('code')));
      dispatch(_immutable2.actions.change(model2, '[' + item.get('code') + '] - ' + item.get('name')));
      _this._closeSearch();
    };

    _this._reset = function () {
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          model = _this$props5.model,
          model1 = _this$props5.model1,
          model2 = _this$props5.model2;

      dispatch(_immutable2.actions.change(model, 0));
      dispatch(_immutable2.actions.change(model1, ''));
      dispatch(_immutable2.actions.change(model2, ''));
    };

    _this.state = {
      openSearch: false,
      filtered: props.searchResults
    };
    return _this;
  }

  // F10 - keyCode = 121


  // fires on Search


  // on select search result item


  BisuReactRowSearch.prototype.render = function render() {
    var _state = this.state,
        openSearch = _state.openSearch,
        filtered = _state.filtered;
    var _props = this.props,
        placeholder = _props.placeholder,
        model = _props.model,
        model1 = _props.model1,
        model2 = _props.model2,
        label1 = _props.label1,
        label2 = _props.label2,
        required = _props.required,
        autoFocus = _props.autoFocus,
        searchResults = _props.searchResults,
        isOffline = _props.isOffline,
        disabled = _props.disabled;


    var results = isOffline ? filtered : searchResults;

    return _react2.default.createElement(
      _reactGridforms.Row,
      { className: 'bisu--react-row-search' },
      _react2.default.createElement(
        _reactGridforms.Field,
        { span: '1', 'data-disabled': disabled ? 'true' : '' },
        _react2.default.createElement(
          'label',
          { htmlFor: model1 },
          label1,
          ' ',
          required && _react2.default.createElement(
            'span',
            { className: 'req' },
            '*'
          )
        ),
        _react2.default.createElement(
          _InputGroup2.default,
          null,
          _react2.default.createElement(
            _InputGroup.Button,
            null,
            _react2.default.createElement(
              'button',
              { type: 'button', onClick: this._openSearch, tabIndex: '-1', disabled: disabled, className: 'btn-icon' },
              _react2.default.createElement(_search2.default, null)
            )
          ),
          _react2.default.createElement(_immutable2.Control.text, {
            model: model1,
            className: 'form-control',
            onKeyDown: this._onKeyDown,
            autoFocus: autoFocus,
            disabled: disabled
          }),
          (0, _bisuReactFormError2.default)(model)
        )
      ),
      _react2.default.createElement(
        _reactGridforms.Field,
        { span: '3', 'data-disabled': 'true', className: 'display' },
        _react2.default.createElement(_bisuReactInput2.default, {
          model: model2,
          label: label2,
          disabled: true
        }),
        _react2.default.createElement(_search4.default, {
          placeholder: placeholder,
          isOpen: openSearch,
          results: results,
          handleClose: this._closeSearch,
          onSubmit: this._onSearch,
          onSelectItem: this._onSelectSearchItem
        })
      )
    );
  };

  return BisuReactRowSearch;
}(_react.Component);

process.env.NODE_ENV !== "production" ? BisuReactRowSearch.propTypes = {
  placeholder: _propTypes.string,
  model: _propTypes.string,
  model1: _propTypes.string,
  model2: _propTypes.string,
  label1: _propTypes.string,
  label2: _propTypes.string,
  searchResults: _propTypes.object,
  onSearch: _propTypes.func,
  autoFocus: _propTypes.bool,
  isOffline: _propTypes.bool
} : void 0;

exports.default = (0, _reactRedux.connect)()(BisuReactRowSearch);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-row-search/lib/index.js
// module id = 151
// module chunks = 0